module.exports = __webpack_public_path__ + "img/marker-oil-export-red.f99207fc.png";